import { LegalEntityCountry } from '@seapoint/server/enums';
import deFlag from '../assets/images/flag-eu.svg';
import gbFlag from '../assets/images/flag-gb.svg';
import ieFlag from '../assets/images/flag-ie.svg';
import { exhaustiveCheck } from './exhaustive-check';

export const getCountryFlag = (countryCode: LegalEntityCountry) => {
  switch (countryCode) {
    case LegalEntityCountry.GB:
      return gbFlag;
    case LegalEntityCountry.IE:
      return ieFlag;
    case LegalEntityCountry.DE:
      return deFlag;
    default:
      return exhaustiveCheck(countryCode);
  }
};
